module.exports = __webpack_public_path__ + "img/logo.197a5640.png";